import React from 'react';

import { FormattedMessage } from 'react-intl';

import messages from './messages';
import { PaginationDetailsStyled } from './styled';

interface Props {
	itemsCount: number;
	totalCount: number | null;
}

export const PaginationDetails = ({ itemsCount, totalCount }: Props): React.JSX.Element => (
	<PaginationDetailsStyled data-testid="paginated-picker.ui.async-select.pagination-details">
		<FormattedMessage
			{...(totalCount === null ? messages.loadedCount : messages.ofTotalCount)}
			values={{
				itemsCount,
				totalCount,
			}}
		/>
	</PaginationDetailsStyled>
);

export default PaginationDetails;
